var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgI(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "1em",
    height: "1em",
    viewBox: "0 0 369 369",
    fillRule: "evenodd",
    clipRule: "evenodd",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    id: "svg-sprite-info2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bfcfil0",
    d: "M184 0c102 0 185 83 185 184 0 102-83 185-185 185C83 369 0 286 0 184 0 83 83 0 184 0zm8 71c17 0 30 14 30 30-1 17-14 30-30 30-17 0-30-14-30-30 0-17 14-30 30-30zm43 202c-9 33-97 36-91-9 4-30 10-59 15-88 3-19-9-13-20-17-7-3-7-12 2-14 11-3 50-1 63-1 7 0 11 4 12 11 0 6-1 11-2 17-5 28-12 58-16 86 0 6 1 17 10 16 9 0 13-4 20-7 4-2 8 1 7 6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgI);
export default __webpack_public_path__ + "static/media/i.b1c50e08.svg";
export { ForwardRef as ReactComponent };